// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.surgeryhistory.CreateSurgeryHistoryRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateSurgeryHistoryRequest extends GandalfModelBase {

	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: Number })
	eyeId!: number | null;

	@GandalfValidator({ notNull: { message: 'Surgery date estimated is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	isSurgeryDateEstimated!: boolean;

	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfValidator({ notNull: { message: 'Snomed code is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	snomedCodeId!: number;

	@GandalfProperty({ designType: Number })
	surgeonProviderId!: number | null;

	@GandalfValidator({ notNull: { message: 'Surgery date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	surgeryDate!: Date;

}
